import React, { useCallback, useMemo } from "react";
import { DataTable } from "@td/ui";
import { useModals } from "../contexts/modals-context";
import { useProviderPanels } from "../contexts/provider-panels-context";
import { modalTypes } from "../constants";
import { mapColumnsBySpecialty } from "../utils";

const ListView = React.memo(() => {
  const { openModal } = useModals();
  const { providerPanels, loading, initializing, specialtyCode } = useProviderPanels();

  const handleModalOpen = useCallback((providerPanel) => () => {
    const { provider, practiceTeamParticipant } = providerPanel;

    openModal(modalTypes.PROVIDER_PANEL_MODAL, {
      providerId: provider.id,
      ...(!!practiceTeamParticipant && { practiceTeamParticipantId: practiceTeamParticipant.id })
    });
  }, [openModal]);

  const columns = useMemo(() => mapColumnsBySpecialty({ specialtyCode, handleModalOpen }), [specialtyCode, handleModalOpen]);

  return (
    <DataTable
      columns={columns}
      data={providerPanels}
      loading={initializing || loading}
    />
  );
});

ListView.displayName = "ListView";

export default ListView;
